import React from "react";
import { Link } from "gatsby-plugin-react-i18next";
import StarIcon from "../../assets/images/star-icon.png";
import ServiceIcon1 from "../../assets/images/services/service-icon1.png";
import ServiceIcon2 from "../../assets/images/services/service-icon2.png";
import ServiceIcon3 from "../../assets/images/services/service-icon3.png";
import { useTranslation } from "gatsby-plugin-react-i18next";

const CPc = () => {
	const { t } = useTranslation();

	return (
		<section className="services-area pt-100 pb-70 bg-f1f8fb">
			<div className="container">
				<div className="section-title">
					<span className="sub-title">
						<img src={StarIcon} alt="sevice" />
						CROWLR Recruitment CRM software
					</span>
					<h2>{t("home.CPch2")}</h2>
					<p>{t("home.CPcp")}</p>
				</div>

				<div className="row">
					<div className="col-lg-4 col-md-6 col-sm-6">
						<div className="single-services-item-box">
							<div className="icon">
								<img src={ServiceIcon1} alt="Service Icon" />
							</div>
							<h3>
								<ref to="/candidature-interactive-et-employabilité">
									{t("home.CPcp1")}
								</ref>
							</h3>
							<p>{t("home.CPcp2")}</p>
							<Link
								to="/interactive-job-candidacy-and-employability"
								className="read-more-btn"
							>
								Read More <i className="flaticon-right"></i>
							</Link>
						</div>
					</div>

					<div className="col-lg-4 col-md-6 col-sm-6">
						<div className="single-services-item-box">
							<div className="icon">
								<img src={ServiceIcon2} alt="Service Icon" />
							</div>
							<h3>
								<ref to="/autopromotion-et-communautée-de-talents">
									{t("home.CPcp3")}
								</ref>
							</h3>
							<p>{t("home.CPcp4")}</p>
							<Link
								to="/selfpromotion-and-talent-community"
								className="read-more-btn"
							>
								Read More <i className="flaticon-right"></i>
							</Link>
						</div>
					</div>

					<div className="col-lg-4 col-md-6 col-sm-6">
						<div className="single-services-item-box">
							<div className="icon">
								<img src={ServiceIcon3} alt="Service Icon" />
							</div>
							<h3>
								<ref to="/prequalification-rgpd-and-anonymous-candidacy">
									{t("home.CPcp5")}
								</ref>
							</h3>
							<p>{t("home.CPcp6")}</p>
							<Link
								to="/employee-reference-solutions"
								className="read-more-btn"
							>
								Read More <i className="flaticon-right"></i>
							</Link>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default CPc;
